import { formatDate } from './formatDate';

const formatDisclosureWithDate = (disclosure: string) => {
  return disclosure?.replace('%today%', formatDate(new Date()));
};

export default formatDisclosureWithDate;
